import {
    getDetail, getCredit
} from "@/api/course"
import Comment from "@/components/Comment"

export default {
    name: 'detail',
    components: {
        Comment
    },
    data() {
        return {
            hideRule: true,
            id: 0,
            course_data: {
                videos: [
                    {
                        videourl: '',
                        poster: ''
                    },               
                ]
            },

            videoOptions: {
                aspectRatio:"16:9",//显示比率
                autoplay: true,
                controls: true,
                sources: [{
                    src: "https://activity.sznews.com/2021/psxly/uploads/20210708/aea1df90834f04bec20240ba16fdda14.mp4",
                    type: ""
                }],
                // children: [
                //     'bigPlayButton'
                // ],

                // isPlaying: false,
                // isBegin: false,

            },
            played: false,
            finished: false,
            timer: null,
            currentTime: 0,
            curVid: 0,
        }
    },

    methods: {

        changeVideo(index) {
            console.log(this.course_data['videos'][index]);
            this.curVid = index

            this.played = false
            this.finished = false
            this.currentTime = 0

            if(this.timer) {
                clearInterval(this.timer)
            }
            

        },

        getCreditBegin() {
            const that = this;
            let post_data = {
                vid: that.course_data.videos[that.curVid].id,
                type: 'begin'
            }
            getCredit(post_data).then(res => {
                console.log(res);
            }).catch(rej => {
                console.log(rej);
            })
        },
        getCreditEnd() {
            const that = this;
            let post_data = {
                vid: that.course_data.videos[that.curVid].id,
                type: 'end'
            }
            getCredit(post_data).then(res => {
                console.log(res);
            }).catch(rej => {
                console.log(rej);
            })
        },



        bindVideo() {
            const that = this;
            console.log(that.$refs.video);

            let video = that.$refs.video
            video.addEventListener('play', function(e) {
                const _this = this;
                // if(!that.timer) {
                //     that.timer = setInterval(() => {
                //         that.currentTime++
                //         console.log(that.currentTime, _this.duration);
                //         if(that.currentTime >= _this.duration) {
                //             clearInterval(that.timer)
                //             that.timer = null
                //         }
                //     }, 1000);
                // } 

                if(!that.played) {
                    that.played = true
                    that.getCreditBegin()
                    that.timer = setInterval(() => {
                        that.currentTime++;
                        if(that.currentTime >= _this.duration) {
                            clearInterval(that.timer)
                            that.getCreditEnd()
                        }else if(that.$route.name != 'Detail') {
                            clearInterval(that.timer)
                        }
                    }, 1000);
                }

            })
            video.addEventListener('seeked', function(e) {
                console.log('seeked', e);
                // clearInterval(that.timer);
                that.timer = null
                if(this.currentTime != that.currentTime) {
                    this.currentTime = that.currentTime
                    this.pause()
                }
                
            })

            
            // video.addEventListener('timeupdate', function(e) {
            //     that.currentTime = this.currentTime;
            //     console.log('timeupdate', this.currentTime);
            // })
            // const videoContainer = document.getElementById('video-container')

            // const video = document.querySelector('#video-container>.video-video');

            // videoContainer.onclick = function(e) {


            //     if(e.target.classList.contains('video-btn')) {
            //         that.videoOptions.isBegin = true;
            //         that.videoOptions.isPlaying = true;
            //         video.play()
            //     }

                





            // }
            // video.onclick = function(e) {
            //     if(that.videoOptions.isPlaying) {
            //         video.pause()
            //     }
            // }


        }


    },

    created() {

        this.videoOptions.width = window.innerWidth
        this.videoOptions.height = window.innerWidth * 9 / 16

    },

    mounted() {
        
        
        const that = this;

        that.id = that.$route.query.id


        getDetail({
            id: that.id
        }).then(res => {

            that.course_data = res.data;
            // for(let key in res.data.videos) {
            //     let video = res.data.videos[key];
            //     that.videoOptions.sources[key].src = video.videourl
            // } 

            that.$nextTick(function() {
                that.bindVideo()
            })
            



        }).catch(rej => {

        })


    },




}